import { Typography, Box,Card, CardContent } from '@mui/material';

export default function GameModeCard({ id, image, title, subtitle, onClick }) {
    console.log(title)
  return (
    <Card
      id={id}
      onClick={onClick}
      className="cursor-pointer transition-transform hover:scale-105 hover:shadow-[0_0_20px_#00E5FF] bg-[#0A0F0D] border-2 border-[#1E1533] rounded-2xl overflow-hidden w-72 text-center"
      sx={{width:{xs:200,lg: 400},display:"flex",flexDirection: "column",
    justifyContent: "flex-end", borderRadius:8, borderColor:"green.main",height:400,display:"flex",backgroundImage:`url(${image})`,backgroundSize: 'cover',
backgroundRepeat: 'no-repeat',
backgroundPosition: 'center',boxShadow: '9px 5px 0px 0px rgb(255 0 153)',margin:2}}
    >
      <CardContent className="p-4" sx={{backgroundColor:"rgba(0, 0, 0, 0.9)"}}>
        <Typography
          variant="h6"
          sx={{
            color: '#00E5FF',
            textAlign:"center",
            mb:1
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: '#FF2D95',
            textAlign: 'center',

          }}
        >
          {subtitle}
        </Typography>
      </CardContent>
    </Card>
  );
}
